import CloseIcon from "./assets-jsx/CloseIcon"

/**
 * This is a legacy toast component that is used to display a toast message. like we did in the old days. (PHP, React in PHP)
 */
export function LegacyToast({ title, onClose }:Props) {
    // TODO: implement colors - success, error, warn, default
    return (
      <div
        className="bg-[#5DC288] text-white flex w-full rounded-none p-2 px-8 shadow items-center relative md:min-w-[500px]"
        role="alert"
      >
        <div className="flex-1 text-center [text-shadow:_0px_1px_1px_#777]">
          {title}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="text-white hover:text-gray-100 inline-flex h-6 w-6 items-center justify-center absolute top-1 right-1"
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <CloseIcon className="stroke-white h-2 w-2" strokeWidth={4} />
          </button>
        )}
      </div>
    );
}

interface Props {
  color: "success";
  title: string;
  onClose?: () => void;
}